import styled from 'styled-components'
import { Loader as SemanticLoader } from 'semantic-ui-react'

export const Loader = styled(SemanticLoader)`
  margin-top: 34px !important;
  margin-left: -34px !important;
`
